module.exports = __webpack_public_path__ + "assets/img/man.ff2b84ad.png";